/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Icons from 'consts/icons';
import CircleButton from 'components/common/components/CircleButton';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { useSelector } from 'react-redux';
import { formStyles } from 'consts/styles/Form';
import EachSideAdminContentHandler from 'components/user/admin/users/EachSideAdminContentHandler';
import ShowUsers from './DisplayUsersRender/DisplayUsersRender';

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const UsersToDisplay = props => {
  const {
    users,
    organizations,
    iconEditActionFunction,
    setAddNewUserFlag,
  } = props;
  const usersActive = users.filter(user => user.isActive_);
  const usersDisabled = users.filter(user => !user.isActive_);

  const [value, setValue] = React.useState(0);

  const strings = useSelector(state => state.language.adminZone.userList);
  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const subtitles = useString().adminZone.user;

  const formClasses = formStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabsAction = React.useRef();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      tabsAction.current.updateIndicator();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [ShowUsers]);

  return (
    <div>
      <div
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
      >
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
        >
          {users.length ? strings.header_ : strings.noUsers_}
        </Typography>

        <CircleButton
          toolTipText={subtitles.addUserButton_}
          onClickFunction={() => setAddNewUserFlag(true)}
          position={{ margin: '0 15px' }}
          size={25}
          PassedIcon={<Icons.Actions.Add2 />}
        />
      </div>
      <div>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          variant="fullWidth"
          centered
          classes={{
            root: `${formClasses.Form}__text-field`,
            indicator: `${formClasses.Form}__tabs__button ${formClasses.Form}__tabs__button--width`,
          }}
          action={tabsAction}
        >
          <Tab label={subtitles.activeUsers} {...a11yProps(0)} />
          <Tab label={subtitles.inactiveUsers} {...a11yProps(1)} />
        </Tabs>
      </div>
      <EachSideAdminContentHandler value={value} index={0}>
        <ShowUsers
          users={usersActive}
          organizations={organizations}
          iconEditActionFunction={iconEditActionFunction}
        />
      </EachSideAdminContentHandler>
      <EachSideAdminContentHandler value={value} index={1}>
        <ShowUsers
          users={usersDisabled}
          organizations={organizations}
          iconEditActionFunction={iconEditActionFunction}
        />
      </EachSideAdminContentHandler>
    </div>
  );
};

UsersToDisplay.propTypes = {
  users: PropTypes.array.isRequired,
  organizations: PropTypes.array.isRequired,
  iconEditActionFunction: PropTypes.func.isRequired,
  setAddNewUserFlag: PropTypes.func,
};

export default UsersToDisplay;
